<template>
  <div class="picker-box">
    <div class="picker-title">发票类型</div>
    <div class="picker-content" @click="openPicker">
      <span>{{currentText}}</span><i class="iconfont iconarrow-right"></i>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    dataList: {
      default() {
        return []
      },
      type: Array
    },
    defaultType: {
      default() {
        return null
      },
      type: Number
    }
  },
  computed: {
    currentText() {
      return this.dataList.filter(item => item.value === this.defaultType)[0].text;
    }
  },
  methods: {
    openPicker() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '发票类型选择',
          data: [this.dataList],
          onSelect: this.changeType,
        })
      }
      this.picker.show();
    },
    changeType(content) {
      this.$emit('select',content[0]);
    }
  }
}
</script>


<style lang="scss" scoped>
.picker-box {
  width: 92%;
  padding: 0 4%;
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .picker-title {
    font-size: 15px;
    color: #4d4d4d;
  }
  .picker-content {
    font-size: 15px;
  }
}
</style>
